import { post } from "../http";

// 学习报告
export const getStudyInfo = params => post(`/app/courseChapter/report`, params);
export const getAppId = params => post(`/web/wechat/appId`, params);
export const getSdk = params => post(`/web/wechat/signatureForJsSdk`, params);
